export enum MovementObjectiveCode {
    NAVIGATION = "NAVIGATION",
    MAINTENANCE = "MAINTENANCE",
    SINGLE = "SINGLE"
}